import DailySeanceItemComponent from 'app/components/DailySeanceItemComponent';
import { DailySeancesSingleCinemaProps } from 'app/containers/Seances/DailySeancesSingleCinemaContainer';

const DailySeancesSingleCinemaComponent = ({
	preparedDailySeances,
	seanceDisplaySettings,
	currencySymbol,
	isMonitor
}: DailySeancesSingleCinemaProps) => {
	return (
		<>
			{
				preparedDailySeances.map(seance => (
					<DailySeanceItemComponent
						isMonitor={isMonitor}
						key={seance.id}
						seanceData={seance}
						seanceDisplaySettings={seanceDisplaySettings}
						currencySymbol={currencySymbol}
					/>
				))
			}
		</>
	);
};

export default DailySeancesSingleCinemaComponent;
